if (!window.requestIdleCallback) {
  window.requestIdleCallback = function(cb, options) {
    var start = Date.now();
    var timeout = (options && options.timeout) ? options.timeout : 1;
    return setTimeout(function() {
      cb({
        didTimeout: false,
        timeRemaining: function() {
          return Math.max(0, 50 - (Date.now() - start));
        }
      });
    }, timeout);
  };
  window.cancelIdleCallback = function(id) {
    clearTimeout(id);
  };
}
